export enum HeroTopicFrontTextAlignment {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}

export const heroTopicFrontTextAlignmentClasses: Record<
  HeroTopicFrontTextAlignment,
  string
> = {
  [HeroTopicFrontTextAlignment.LEFT]: 'u-textLeft',
  [HeroTopicFrontTextAlignment.CENTER]: 'u-textCenter u-flexJustifyCenter',
  [HeroTopicFrontTextAlignment.RIGHT]: 'u-textRight u-flexJustifyEnd'
}
